import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

const Grid = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'grid h-auto w-full grid-cols-4 gap-x-gutter md:grid-cols-12',
          className
        )}
        {...props}
      />
    )
  }
)

export default Grid
